var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#122442",
    d: "M3.6 8.403c1.444 2.844 3.756 5.156 6.6 6.6l2.2-2.2c.117-.144.281-.243.464-.28.182-.036.372-.008.536.08 1.156.41 2.374.613 3.6.6.263.007.514.114.7.3.186.186.294.437.3.7v3.5c-.006.263-.114.514-.3.7-.186.186-.437.294-.7.3-4.503-.019-8.816-1.816-12-5-3.184-3.184-4.981-7.497-5-12 .006-.263.114-.514.3-.7.186-.186.437-.294.7-.3h3.5c.263.006.514.114.7.3.186.186.294.437.3.7.004 1.225.207 2.44.6 3.6.05.17.059.35.024.525-.035.174-.112.337-.224.475l-2.3 2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.0759c598.svg";
export { ForwardRef as ReactComponent };